import { pathnameWithoutLocalePrefix } from '@/util/localePath'

export const SPORTS_CATEGORY_SLUG = 'sports'
export const SOCCER_CATEGORY_SLUG = 'soccer'

const marketSegments = pathname =>
  pathnameWithoutLocalePrefix(String(pathname || ''))
    .replace(/^\/|\/$/g, '')
    .split('/')

/**
 * True anywhere under the Sports root — `/markets/sports/`, `/markets/sports/nfl/553`,
 * a soccer league. Every feed there lists fixtures. The locale prefix is stripped here
 * rather than at the call sites, so a `/pt-br` URL is not read as a different category.
 */
export function isSportsCategoryPath(pathname) {
  const segments = marketSegments(pathname)
  return segments[0] === 'markets' && segments[1] === SPORTS_CATEGORY_SLUG
}

/**
 * True on the soccer tab and every league under it — `/markets/sports/soccer/8`,
 * `/markets/sports/soccer/federative-republic-of-brazil/serie-b/82`.
 */
export function isSoccerCategoryPath(pathname) {
  const segments = marketSegments(pathname)
  return segments[0] === 'markets' && segments[1] === SPORTS_CATEGORY_SLUG && segments[2] === SOCCER_CATEGORY_SLUG
}
